import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class ImageSchemaPlugin extends SchemaPlugin {
  nodes = {
    image: {
      inline: true,
      attrs: {
        src: { default: undefined },
        alt: { default: undefined },
        title: { default: undefined }
      },
      group: 'inline',
      draggable: true,
      parseDOM: [{
        tag: 'img',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['src', 'alt', 'title']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'img',
      isVoid: true
    },

    map: {
      group: 'block',
      content: 'inline*',
      parseDOM: [{
        tag: 'map'
      }],
      toDOM(node) { return nodeToDOM(node); }
    },

    area: {
      group: 'inline',
      content: 'inline*',
      inline: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'area',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      isTagNameBox: true,
      isVoid: true
    },

    picture: {
      group: 'inline',
      content: 'inline*',
      inline: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'picture',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); }
    },
  } satisfies Record<string, NodeSpec>;
}
